import { useContext, useEffect, useState } from "react";
import { HabilidadesContext } from "../../contexts/HabilidadesContext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { Rating } from "primereact/rating";
import "./Habilidades.css";

export const ModalPracticas = ({
  visible,
  setVisible,
}) => {
  const {
    getPracticas,
    getUsuarioPracticas,
    postUsuarioPracticas,
    delUsuarioPracticas,
  } = useContext(HabilidadesContext);

  const [practicas, setPracticas] = useState([]);
  const [practicasSeleccionadas, setPracticasSeleccionadas] = useState([]);
  const [practicasEliminar, setPracticasEliminar] = useState([]);

  useEffect(() => {
    const fecthData = async () => {
      const data = await getPracticas();
      const mapData = data.map((value) => ({
        practicaId: value.id,
        nombre: value.nombre,
      }))
      setPracticas(mapData)
    }
    fecthData()
  }, []);

  useEffect(() => {
    const fecthData = async () => {
      const data = await getUsuarioPracticas();
      if (!Array.isArray(data) || data.length === 0) {
        setPracticasSeleccionadas([]);
        return;
      }
      const mapData = data.map((value) => ({
        id: value.id,
        practicaId: value.practicaId,
        nombre: value.practicaNombre,
        valoracion: value.valoracion,
      }))
      setPracticasSeleccionadas(mapData)
    }
    if (practicas.length > 0) {
      fecthData()
    }
  }, [practicas, visible]);

  const handlePracticasSelect = (e) => {
    const selectedIds = e.value;
    const nuevasSeleccionadas = selectedIds.map((pid) => {
      const practica = practicas.find((p) => p.practicaId === pid);
      const yaSeleccionada = practicasSeleccionadas.find((p) => p.practicaId === pid);
      return {
        ...practica,
        id: yaSeleccionada?.id,
        valoracion: yaSeleccionada?.valoracion ?? null,
      };
    });
    setPracticasSeleccionadas(nuevasSeleccionadas);
  };

  const handleRating = (e, value) => {
    const updateRating = practicasSeleccionadas.map((ps) => {
      if (ps.practicaId === value.practicaId) {
        return { ...ps, valoracion: e.value }
      }
      return ps;
    })
    setPracticasSeleccionadas(updateRating)
  }

  const quitarPracticaSeleccionada = (ps) => {
    const filter = practicasSeleccionadas.filter((value) => value.practicaId !== ps?.practicaId);
    setPracticasSeleccionadas(filter);
    if (ps?.id) {
      setPracticasEliminar(prev => [...prev, ps.id]);
    }
  }

  const handleGuardarUsuarioPracticas = async () => {
    const normalizeData = practicasSeleccionadas.map((ps) => ({
      practicaId: ps.practicaId,
      valoracion: ps.valoracion
    }));
    if (practicasEliminar) {
      await delUsuarioPracticas(practicasEliminar)
    }
    await postUsuarioPracticas(normalizeData);
    setVisible(false);
  };

  return (
    <Dialog
      draggable={false}
      closable={true}
      id="custom-bg-modal"
      style={{
        minWidth: "614px",
        maxWidth: "800px",
        height: "500px",
      }}
      className="custom-modal"
      visible={visible}
      position={"center"}
      onHide={() => setVisible(false)}
      header={<div>
        <p className="p1-modal-habilidades">Agregar Prácticas</p>
      </div>}
    >
      <div style={{ padding: "15px 20px 10px 20px" }}>
        <label className="h2-modal-habilidades">Práctica</label>

        <MultiSelect
          placeholder="Seleccioná una práctica"
          style={{ width: "100%", height: "41px" }}
          className="w-full md:w-20rem select-clientes-home"
          panelClassName="modal-skills"
          filter
          options={practicas}
          optionLabel="nombre"
          optionValue="practicaId"
          value={practicasSeleccionadas.map((p) => p.practicaId)}
          onChange={handlePracticasSelect}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "0px 20px 10px",
          overflowY: "auto",
        }}
      >
        {practicasSeleccionadas.map((value) => (
          <div key={`main-div-${value.practicaId}`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 20px 10px",
            }}
          >
            <div key={`list-div-${value.practicaId}`} className="filtros-select">
              <p>{value.nombre}</p>
              <i
                className="pi pi-times-circle custom-icon-habilidades"
                style={{ cursor: "pointer" }}
                onClick={() => quitarPracticaSeleccionada(value)}
              ></i>
            </div>
            <Rating
              value={value?.valoracion || 0}
              disabled={value.validated}
              onChange={(e) => handleRating(e, value)}
              cancel={false}
            />
          </div>
        ))}
      </div>

      <footer className="footer-modal-habilidades">
        <Button
          className="button-modal-habilidades-cancelar"
          onClick={() => {
            setVisible(false);
          }}
        >
          Cancelar
        </Button>
        <Button
          className="button-modal-habilidades"
          onClick={() => {
            handleGuardarUsuarioPracticas()
          }}
        >
          Guardar
        </Button>
      </footer>

    </Dialog>
  );
};
